import { Pattern, RegisterPattern } from "../../Pattern.js"

RegisterPattern(Pattern.ParsePatFile(`
*LINE,LINE
0, 0,0, 0,3.175
`))
